import * as lookups from "mortar/endpoints/lookups";
import * as commodities from "mortar/endpoints/commodities";

export const getCertificateTypes = () => lookups.certificateTypesLookup();

export const getCommodities = () =>
  commodities.listCommodities({ queryParams: { search: null } });

export const getRegionOffices = () => lookups.regionOfficesLookup();
